import script from "./LevelOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./LevelOverview.vue?vue&type=script&setup=true&lang=js"

import "./LevelOverview.vue?vue&type=style&index=0&id=19742312&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19742312"]])

export default __exports__